module.exports = __webpack_public_path__ + "static/media/Logo-EXIST.59456d26.png";